function forEachDatatable(f) {
  let $datatables = $("table[data-datatable-ajax--url]")
  if (!$datatables.length)
    return

  import("./datatables").then((r) => {
    $datatables.each(function () {
      f($(this), r)
    })
  })
}

function recomputeVisibleDatatables() {
  $("table[data-datatable-ajax--url]:visible").each(function () {
    $(this).data("editableDatatable")?.recomputeScrollY()
  })
}

$(document).on("turbolinks:load", () => {
  forEachDatatable(($elem, { EditableDatatable }) => {
    new EditableDatatable($elem).init()
  })
})

$(document).on("turbolinks:before-cache", function () {
  forEachDatatable(($elem, { EditableDatatable }) => {
    $elem.data(EditableDatatable.DATA_PROPERTY_NAME)?.destroy()
  })
})

$(document).on("shown.bs.tab", () => {
  recomputeVisibleDatatables()
})

let resizeTimer
$(window).on("resize.editableDatatable", () => {
  clearTimeout(resizeTimer)
  resizeTimer = setTimeout(recomputeVisibleDatatables, 150)
})